import { Routes } from '@angular/router';

// The check pages moved under /checks (SPAR-973). These redirects stay for good so the old
// links pasted into Jira and Slack keep working.
// - redirectTo must be relative: in Angular 17 an absolute redirect rebuilds the query params
//   from the redirectTo string alone (applyRedirectCreateUrlTree in @angular/router), which
//   would drop the filters these links carry.
// - pathMatch 'full' keeps /projects/missing-fields/import from being redirected.
// - They are spread into the app routes ahead of 'projects', so /projects/missing-fields
//   can't fall through to 'projects/:id'.
export const LEGACY_CHECK_REDIRECTS: Routes = [
  { path: 'invoices/po-check', redirectTo: 'checks/po', pathMatch: 'full' },
  { path: 'invoices/invoice-check', redirectTo: 'checks/invoices', pathMatch: 'full' },
  { path: 'projects/missing-fields', redirectTo: 'checks/missing-fields', pathMatch: 'full' },
  { path: 'projects/linked-projects-check', redirectTo: 'checks/linked-projects', pathMatch: 'full' },
];
